import React from 'react';
import ComingSoon from '../components/popup-registration/Coming-soon';

const MontrealForm = () => <ComingSoon/>;
export default MontrealForm;